// Updated redirect URL for production
import { supabase } from './config/supabaseClient'

export const sendMagicLink = async (email: string): Promise<boolean> => {
  const redirectUrl = 'https://ibdrant.com'
  
  console.log('Attempting to send magic link to:', email) // Debug log
  
  const { data, error } = await supabase.auth.signInWithOtp({
    email: email,
    options: {
      emailRedirectTo: redirectUrl,
    },
  })

  if (error) {
    console.error('Error sending magic link:', error)
    return false
  }

  console.log('Magic link sent successfully:', data) // Debug log
  return true
}

export const getCurrentUser = async () => {
  const {
    data: { user },
  } = await supabase.auth.getUser()
  return user
}

export const isUserLoggedIn = async (): Promise<boolean> => {
  const user = await getCurrentUser()
  return !!user
}

export const saveDisplayName = async (
  displayName: string,
): Promise<boolean> => {
  const {
    data: { user },
  } = await supabase.auth.getUser()

  if (!user) {
    console.error('No user logged in')
    return false
  }

  const { error } = await supabase.from('profiles').upsert({
    id: user.id,
    display_name: displayName,
  })

  if (error) {
    console.error('Error saving display name:', error)
    return false
  }

  return true
}

export const getDisplayName = async (
  userId: string,
): Promise<string | null> => {
  const { data, error } = await supabase
    .from('profiles')
    .select('display_name')
    .eq('id', userId)
    .single()

  if (error || !data) {
    return null
  }

  return data.display_name
}

export const signOut = async (): Promise<void> => {
  const { error } = await supabase.auth.signOut()
  if (error) {
    console.error('Error signing out:', error)
  }
}
